module.exports = __webpack_public_path__ + "img/newsletter.9d4dcb43.svg";